import formatValue from "./FormatValue";

export const transposeDataColumns = (data, columns) => {
    let newColumns = [];
    let newData = [];
    if (columns.length) {
        let transposeColumn = columns[0]; //get first col
        newColumns.push({
            name: transposeColumn.name,
            label: transposeColumn.label,
            type: 'string',
            ...transposeColumn,
        });
        for (let item of data) {
            newColumns.push({
                name: item[transposeColumn.name],
                label: formatValue(item[transposeColumn.name], transposeColumn.type, null),
                type: 'string',
                ...item,
            });
        }
        
        for (let column of columns) {
            if (column.name !== transposeColumn.name) {
                let newItem = {[transposeColumn.name]: column.label, __props: {}};
                for (let item of data) {
                    for (let key in item) {
                        if (key !== transposeColumn.name) {
                            newItem.__props.type = column.type;
                            newItem[item[transposeColumn.name]] = item[column.name]
                        }
                    }
                }
                newData.push(newItem)
            }
        }
    }
    return {newData, newColumns}
};